module.exports = __webpack_public_path__ + "static/media/gs.9c1ee706.webp";